import React from 'react';
export function Experience() {
  return <section id="experience" className="py-20 bg-white" data-id="element-45">
      <div className="container mx-auto px-4 md:px-6" data-id="element-46">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-16 items-center" data-id="element-47">
          <div data-id="element-48">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6" data-id="element-49">
              The Porsche Experience
            </h2>
            <div className="w-24 h-1 bg-red-600 mb-8" data-id="element-50"></div>
            <p className="text-lg text-gray-700 mb-6" data-id="element-51">
              The afternoon session takes place at the state-of-the-art Porsche
              Experience Center Los Angeles, where you'll have the opportunity
              to push the limits of performance vehicles on specialized driving
              modules.
            </p>
            <ul className="space-y-4" data-id="element-52">
              {['Hands-on driving experiences with the latest Porsche models', 'Professional instructors providing personalized coaching', 'Test your skills on the acceleration straight, handling circuit, and low-friction surfaces', 'Experience the technological innovation that defines the Porsche brand'].map((item, index) => <li key={index} className="flex items-start" data-id="element-53">
                  <span className="text-red-600 mr-2" data-id="element-54">•</span>
                  <span data-id="element-55">{item}</span>
                </li>)}
            </ul>
          </div>
          <div className="grid grid-cols-2 gap-4" data-id="element-56">
            <img src="https://images.unsplash.com/photo-1580274455191-1c62238fa333?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1964&q=80" alt="Porsche 911" className="rounded-lg shadow-md w-full h-auto object-cover" data-id="element-57" />
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/iUMrztqwG8cBihTQrKYLGx/converted_image.png" alt="Porsche GT3 RS interior cockpit" className="rounded-lg shadow-md w-full h-auto object-cover mt-8" data-id="element-58" />
          </div>
        </div>
      </div>
    </section>;
}